import { ToastOptions } from './toast.types';

export const DEFAULT_TOAST_OPTIONS: ToastOptions = {
  keepOpen: true,
  showCloseButton: true,
};
